import { render, staticRenderFns } from "./SimpleItem.vue?vue&type=template&id=4e1dadfd"
import script from "./SimpleItem.vue?vue&type=script&lang=js"
export * from "./SimpleItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports